/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import Header from "./common/Header";
import CalendarPage from "./calendar/CalendarPage";
import { styled } from "styled-components";

const Wrapper = styled.div`
  @media (min-width: 800px) {
    display: flex;
    flex-direction: column;
    top: 1rem;
    position: fixed;
    height: 100%;
    background-color: #6492b8;
  }
`;
const Main = styled.main`
  min-height: 800px;
  width: 60%;
  max-width: 800px;
  padding: 0.2em;
  margin: 10px;
  overflow-y: scroll;
  position: relative;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none;
  @media (min-width: 800px) {
    top: 10rem;
    margin-left: 370px;
  }
  @media (max-width: 800px) {
    width: 95%;
    padding: 0.5rem;
    top: 8rem;
    margin: 0px;
    align-items: center;
    background-color: #6492b8;
  }
`;

export default function Layout({ children }) {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 800);

  useEffect(() => {
    window.addEventListener("resize", handleResize);
  }, []);

  function handleResize() {
    if (window.innerWidth < 800) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  }

  return (
    <React.Fragment>
      <Header />
      {!isMobile ? (
        <Wrapper>
            <CalendarPage />
        </Wrapper>
      ) : (
        <></>
      )}
      <Main>{children}</Main>
    </React.Fragment>
  );
}
